import { useRef, useState, useContext } from 'react';
import * as THREE from 'three';
import { useFrame, useThree } from '@react-three/fiber';
import TextInGroup from './TextInGroup';
import LanguageContext from '../../Contexts/Language';

export default function TextGroup(props) {
    const { width: w} = useThree((state) => state.viewport);
    const {language} = useContext(LanguageContext);
    const [currentText, setCurrentText] = useState(-1)
    const colors = [
        {
            color: "#fc371d",
            background: "#fd7f6f",
        },
        {
            color: "#5294c7",
            background: "#7eb0d5",
        },
        {
            color: "#87c026",
            background: "#b2e061",
        },
        {
            color: "#a855aa",
            background: "#bd7ebe",
        },
        {
            color: "#ff981a",
            background: "#ffb55a",
        },
        {
            color: "#f854a8",
            background: "#fb9dce",
        },
        {
            color: "#3fa695",
            background: "#6bc7b8",
        },
    ];
    const groupText = useRef(null);

    useFrame(() => {
        const newScroll = props.scrollValue / (100 / props.zoom)
        if(Math.round(newScroll) - 4 < colors.length){
            setCurrentText(Math.round(newScroll) - 4)
        }
        if(((newScroll) - 4) > 6){
            groupText.current.position.lerp(new THREE.Vector3(props.position[0],(((newScroll) - 10) * (w < 10 ? 1.44 : 1.13)) + 12,0), 1);
        }
        else{
            groupText.current.position.lerp(new THREE.Vector3(props.position[0],((Math.round(newScroll) - 4) * 2),0), 0.07 * 2.5)
        }
    })

    return (
        <group ref={groupText} position={props.position}>
            {
                colors.map((color,key) =>(
                    <group position={[0,(-2 * key),w < 10 ? w - 20 : - 5]}>
                        <TextInGroup key={language.crystal.texts} isVisible={currentText === key ? true : false} color={color.color} background={color.background}>{language.crystal.texts[key]}</TextInGroup>
                    </group>
                ))
            }
        </group>
    )
}